<template>
  <!-- <vx-card v-show="isCardActiveLocal" :style="{ 'background-color': question && question.quizDetails.isGraded ? answer && answer.questionAchievedMarks == answer.questionTotalMarks ? 'rgba(107, 255, 81, 0.3)' : 'rgba(255, 56, 56, 0.3)' : 'none', 'margin-bottom': '1rem' }"> -->
  <vx-card v-show="isCardActiveLocal" :style="{ 'background-color': question && question.quizDetails.isGraded ? answer && answer.questionAchievedMarks == answer.questionTotalMarks ? 'rgba(107, 255, 81, 0.3)' : question && question.quizDetails.isGraded && answer && answer.questionAchievedMarks != answer.questionTotalMarks && answer.questionAchievedMarks && answer.allowPartialScoring ? 'rgba(255, 204, 0, 0.3)' : 'rgba(255, 56, 56, 0.3)' : 'none', 'margin-bottom': '1rem' }">
    <div class="vx-row">
      <div class="vx-col w-full">
        <h5 class="mb-2">{{ answer.questionNumber }}. {{ questionTitle }}</h5>
        <p class="mb-2" style="word-break: break-word;">{{ questionText }}</p>
        <ul>
          <li v-for="(option, optionIndex) in answer.options" :key="optionIndex">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="flex" style="min-height: 27px;">
                  <div v-if="question.quizDetails.isGraded" style="width: calc(21px + 0.5rem)">
                    <feather-icon v-if="option.isSelected && option.isCorrectAnswer" icon="CheckIcon" class="mr-2 correct-icon" svg-classes="h-6 w-6 stroke-current"></feather-icon>
                    <feather-icon v-else-if="option.isSelected && !option.isCorrectAnswer" icon="XIcon" class="mr-2 wrong-icon" svg-classes="h-6 w-6 stroke-current"></feather-icon>
                  </div>
                  <ul class="flex items-left justify-left" style="word-break: break-word;">
                    <li>
                      <p :style="{'color': setOptionColor(option, answer), 'font-weight': setOptionFont(optionIndex, option, answer) }">{{ option.optionNumber }}.</p>
                    </li>
                    <li class="ml-2 resizequillimage">
                      <p :style="{'color': setOptionColor(option, answer), 'font-weight': setOptionFont(optionIndex, option, answer) }" v-html="option.optionText"></p>
                    </li>
                  </ul>
                  <span v-if="option.isCorrectAnswer && question.quizDetails.isGraded" class="ml-3">[Correct Answer]</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <comment-view :isCardActive="commentView" :question="question" :answer="answer" :predefinedComments="predefinedComments" />
  </vx-card>
</template>

<script>
  import commentView from './QuizCommentView.vue';
  export default {
    components: {
      commentView
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      answer: {
        type: Object,
        required: false
      },
      predefinedComments: {
        type: Array,
        required: false
      }
    },
    data() {
      return {
        commentView: true,
        questionText: "",
        questionTitle: ""
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.question){

          }else{
            self.initValues();
          }
        }
      },
      question: function(val) {
        if(val){
          this.commentView = true;
        }
      }
    },
    methods: {
      strip(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      },
      setOptionColor(option, answer) {
        if (this.question.quizDetails.isGraded) {
          if(option.isCorrectAnswer && option.isSelected){
            return '#00cc00';
          }
          else if(option.isSelected && !option.isCorrectAnswer){
            return 'red';
          }
          else{
            return this.$store.state.theme == 'dark' ? '#c5c5c5' : 'black';
          }
        } else {
          if(option.isSelected){
            return '#00cc00';
          }
          else{
            return this.$store.state.theme == 'dark' ? '#c5c5c5' : 'black';
          }
        }
      },
      setOptionFont(optionIndex, option, answer) {
        if(option.isSelected && option.isCorrectAnswer)
          return 700;
        else if(option.isSelected && !option.isCorrectAnswer)
          return 700;
        else
          return 400;
      },
      saveData() {
        this.initValues();
        this.$emit('saveData');
      },
      initValues() {
        
        this.errors.clear();
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
    },
    mounted() {
      if(this.answer){
        this.questionText = this.strip(this.answer.questionText);
        this.questionTitle = this.strip(this.answer.questionTitle);
      }
    }
  }

</script>

<style lang="scss">
  .resizequillimage{
    z-index: 2;
    
    img{
      padding: 10px;
      max-width: 15vw;
      transition: 500ms ease-in-out;
    }
    img::after{
      width: 100%;
      height: 100%;
      z-index: 1;
    }
  
    &:hover{
      img{
        width: 100%;
        height: 100%;
        max-width: 75vw;
      }
      
      p img{
        width: 100%;
        height: 100%;
        max-width: 75vw;
      }
    }
  }
</style>
